import React, { Fragment } from "react";
import { hydrate } from "react-dom";
import ChatWidget from "../../shared_modules/five9-chat-widget";

const getPostMessageForAspen = ({ appState, error }) => ({
  appState,
  error,
  source: "lendingclub",
});

const postParentResponse = ({ appState, error = false }) => {
  if (window !== top) {
    const message = getPostMessageForAspen({ appState, error });
    window.top.postMessage(message, "*");
  }
  return;
};

const renderFive9Chat = (chatFive9Context) => {
  const reactComponent = document.getElementById("five9-chat-wrapper");
  if (reactComponent && chatFive9Context?.isFiveChatEnabled) {
    hydrate(
      <Fragment>
        <ChatWidget chatFive9Context={chatFive9Context} />
      </Fragment>,
      reactComponent,
    );
  }
};

export default {
  postParentResponse,
  getPostMessageForAspen,
  renderFive9Chat,
};

